import React from 'react';
import { Markup } from 'interweave';

import ActionsLockClosedNormalXsmall from '@strava/icons/ActionsLockClosedNormalXsmall';

import { trackV2 } from 'utils/analytics';
import I18n from 'utils/I18n';

import styles from './styles.scss';

const LoggedOutLeaderboard = () => {
  const onLoginClick = () => {
    trackV2({
      page: 'challenge_details',
      category: 'challenges',
      element: 'leaderboard_signup_btn',
      action: 'click'
    });
  }

  return (
    <div className={styles.leaderboard}>
      <div className={styles.content}>
        <a href="/register/free" onClick={onLoginClick}>
          <ActionsLockClosedNormalXsmall aria-hidden="true" />
          <Markup
            tagName="span"
            content={I18n.t(
              'strava.challenges.challenge_detail.leaderboard.signup_html'
            )}
          />
        </a>
      </div>
    </div>
  );
};

export default LoggedOutLeaderboard;
